module.exports = __webpack_public_path__ + "img/base_divers_web.6d49ff10.svg";